import { Button } from '@thedealersconcierge/components';
import { useTranslation } from 'react-i18next';

import Header from '~/components/Header';

import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import { useNavigate, useParams } from '~/router';
import { kioskDealershipAtom } from '~/state/kiosk';
import OpenScannerModal from './_components/OpenScannerModal';

const AdditionalDocumentUploadModeSelector = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { transactionId, dealershipSlug } = useParams(
    '/dashboard/:dealershipSlug/:transactionId/additional-documents'
  );
  const kioskMode = useAtomValue(kioskDealershipAtom);

  return (
    <div className="flex flex-col h-dvh w-full">
      <Header
        title={t('Documents')}
        leftElement={{
          type: 'CANCEL_AND_BACK_TO_TRANSACTION_MAIN_PAGE',
          transactionId,
          dealershipSlug
        }}
      />

      <div className="flex flex-col pt-spacing-04 space-y-spacing-05 w-full items-center overflow-y-auto ">
        <div className="flex flex-col space-y-spacing-04 w-full items-center justify-start mt-spacing-09 md:mt-spacing-10 h-dvh">
          <div className="w-full px-spacing-06 md:px-0 max-w-screen-md">
            <p className="heading-emphasized-02 text-center">
              {kioskMode
                ? t('Instantly Capture Documents with Scanner')
                : t('How Would You Like to Upload Your Documents?')}
            </p>

            {/* Cards */}
            <div
              className={classNames(
                'grid grid-cols-1 justify-items-center gap-spacing-08 mt-spacing-09',
                {
                  'sm:grid-cols-1 md:grid-cols-2': !kioskMode
                }
              )}
            >
              {/* Upload Card */}
              {!kioskMode && (
                <div className="w-full p-spacing-05 bg-primary border border-secondary rounded-radius-02">
                  <div className="flex flex-col items-center text-center gap-spacing-06">
                    <p className="heading-02 font-semibold">
                      {t('Upload from Device')}
                    </p>
                    <p className="text-secondary body-01">
                      {t(
                        'Easily upload documents from your computer, phone, or tablet.'
                      )}
                    </p>
                    <Button
                      label={t('Choose File')}
                      onClick={() => {
                        navigate(
                          '/dashboard/:dealershipSlug/:transactionId/additional-documents/upload',
                          {
                            params: {
                              dealershipSlug: dealershipSlug,
                              transactionId: transactionId
                            }
                          }
                        );
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Scan Card */}
              <div className="w-full p-spacing-05 bg-primary border border-secondary rounded-radius-02">
                <div className="flex flex-col items-center text-center gap-spacing-06">
                  <p className="heading-02 font-semibold">
                    {t('Scan with Camera')}
                  </p>
                  <p className="text-secondary body-01">
                    {t(
                      "Use your device's camera to scan and detect document instantly"
                    )}
                  </p>

                  {/* This will either return a Button on consumer app ans QR Code on kiosk mode */}
                  <OpenScannerModal
                    transactionId={transactionId}
                    dealershipIdentifier={{ dealershipSlug }}
                    openModalLabel={
                      kioskMode ? t('Start Scanning') : t('Scan Documents')
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdditionalDocumentUploadModeSelector;
